(() => {
  if (customElements.get('sgo-toolbox-gift')) return;

  // Shared across instances and variant rerenders to prevent overlapping adds.
  let adding = false;

  class SgoToolboxGift extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.addGift.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('[data-add-gift]');
      this.status = this.querySelector('[role="status"]');
      if (!this.button || !this.status) return;
      this.button.disabled = false;
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    showStatus(message) {
      this.status.textContent = message;
      this.status.hidden = false;
    }

    refreshCart() {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { scrollToTop: false }
      }));
    }

    async addGift(event) {
      if (!event.target.closest('[data-add-gift]')) return;
      event.preventDefault();
      event.stopPropagation();
      if (adding) return;

      adding = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.button.textContent = 'Adding…';
      this.status.hidden = true;
      let submitted = false;

      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartUrl = window.routes?.cartUrl || `${root}cart`;
        const addUrl = window.routes?.cartAddUrl || `${root}cart/add`;
        const variantId = Number(this.dataset.giftVariant);
        const cartResponse = await fetch(`${cartUrl}.js`, {
          credentials: 'same-origin', cache: 'no-store'
        });
        if (!cartResponse.ok) throw new Error('Cart unavailable');
        const cart = await cartResponse.json();

        if (cart.items.some(item => Number(item.variant_id) === variantId && item.quantity > 0)) {
          this.showStatus('Gift pack already in your cart. One free gift per order.');
          this.refreshCart();
          return;
        }

        submitted = true;
        const response = await fetch(`${addUrl}.js`, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        const result = await response.json();
        if (!response.ok) {
          this.showStatus(typeof result.description === 'string'
            ? result.description : 'Gift unavailable. Please check your cart.');
          return;
        }

        this.showStatus('Gift added. Free with an eligible mask in your cart.');
        this.refreshCart();
      } catch (error) {
        this.showStatus(submitted
          ? 'Couldn’t confirm the add. Check your cart before trying again.'
          : 'Couldn’t check your cart. Please try again.');
      } finally {
        adding = false;
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
        this.button.textContent = 'Add gift to cart';
      }
    }
  }

  customElements.define('sgo-toolbox-gift', SgoToolboxGift);
})();
